module.exports = __webpack_public_path__ + "img/additional_btn.03a3413c.png";